// extracted by mini-css-extract-plugin
export default {"root":"InvalidateWarning_root__fQKid","active":"InvalidateWarning_active__OlOrU","placeHolderShimmer":"InvalidateWarning_placeHolderShimmer__KqLFf"};